// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import LandingPage from "./pages/LandingPage";
import SingleBlogPage from "./pages/SingleBlogPage";
import AdminRegister from "./pages/AdminRegister";
import AdminLogin from "./pages/AdminLogin";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import AdminBlogEditor from "./pages/AdminBlogEditor";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AddInterview from "./pages/AddInterview";
import EditInterview from "./pages/EditInterview";
import ViewInterviews from "./pages/ViewInterviews";
import InterviewDetails from "./pages/InterviewDetails";
import SetupInterview from "./pages/SetupInterview";
import SetupQuestions from "./pages/SetupQuestions";
import InterviewSetupWizard from "./pages/InterviewSetupWizard";
import AddRound from "./pages/AddRound";
import ManageQuestions from "./pages/ManageQuestions";
import EditRound from "./pages/EditRound";
import InterviewBoard from "./pages/InterviewBoard";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import PrepMaterials from "./pages/PrepMaterials";
import PreInterviewSetup from "./pages/PreInterviewSetup";
import MockInterview from "./pages/MockInterview";
import MockReport from "./pages/MockInterviewReport";
import HowItWorksWithProgress from "./components/HowItWorksWithProgress";
import ContactUs from "./pages/ContactUs";
import QuickProfileSetup from "./pages/QuickProfileSetup";
import ProfileSetup from "./pages/ProfileSetting";
import MaterialViewer from "./pages/MaterialViewer";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Layout from "./components/Layout";
import AuthCallback from "./pages/AuthCallback";
// Components
import ProtectedRoute from "./components/ProtectedRoute";

function AppRoutes() {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/register" element={<AdminRegister />} />

          <Route path="/admin/blogs/create" element={<AdminBlogEditor />} />
      <Route path="/blogs" element={<BlogList />} />
        <Route path="/blogs/:slug" element={<BlogPost />} />
        <Route path="/admin/blogs/editor" element={<AdminBlogEditor />} />
        <Route path="/blogs/:slug" element={<SingleBlogPage />} />

          
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
       <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/onboarding" element={<QuickProfileSetup />} />
      <Route path="/how-it-works" element={<HowItWorksWithProgress />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/prep" element={<PrepMaterials />} />
      <Route path="/prep/mock/setup" element={<PreInterviewSetup />} />
      <Route path="/prep/mock/:interviewId" element={<MockInterview />} />
      <Route path="/mock/:interviewId/report" element={<MockReport />} />
    <Route path="/prep/materials/:id" element={<MaterialViewer />} />
    <Route path="/auth/google/callback" element={<AuthCallback />} />


      {/* Protected Routes */}
      <Route
        path="/profile-setup"
        element={
          <ProtectedRoute>
            <ProfileSetup />
          </ProtectedRoute>
        }
      />

      <Route
  path="/analytics"
  element={
    <ProtectedRoute>
      <Layout>
        <AnalyticsDashboard />
      </Layout>
    </ProtectedRoute>
  }
/>

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interview-board"
        element={
          <ProtectedRoute>
            <InterviewBoard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews"
        element={
          <ProtectedRoute>
            <ViewInterviews />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add"
        element={
          <ProtectedRoute>
            <AddInterview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/edit/:id"
        element={
          <ProtectedRoute>
            <EditInterview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/:id"
        element={
          <ProtectedRoute>
            <InterviewDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/:id/setup-wizard"
        element={
          <ProtectedRoute>
            <InterviewSetupWizard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/:id/setup"
        element={
          <ProtectedRoute>
            <SetupInterview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/:id/questions"
        element={
          <ProtectedRoute>
            <SetupQuestions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/:interviewId/rounds/new"
        element={
          <ProtectedRoute>
            <AddRound />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/:interviewId/rounds/:roundId/questions"
        element={
          <ProtectedRoute>
            <ManageQuestions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interviews/:interviewId/rounds/:roundId/edit"
        element={
          <ProtectedRoute>
            <EditRound />
          </ProtectedRoute>
        }
      />

      {/* Catch-all → redirect to Landing */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
      {/* Toast Container for global toasts */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
    </Router>
  );
}

export default App;
